import ConfirmationModal from "common/components/ConfirmationModal";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { CONFIRMATION_MESSAGE_DELETE_CONTAINER_ELEMENT } from "../constants";
import { deleteElement, setConfirmDelete } from "../store/editorSlice";

const ConfirmDeleteElement = () => {
  const dispatch = useAppDispatch();
  const confirmDelete = useAppSelector(
    (state) => state.developer.edit.editor.confirmDelete
  );

  const handleConfirm = useCallback(() => {
    dispatch(deleteElement());
  }, [dispatch]);

  const handleCancel = useCallback(() => {
    dispatch(setConfirmDelete(false));
  }, [dispatch]);

  return (
    <ConfirmationModal
      open={confirmDelete}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      title={CONFIRMATION_MESSAGE_DELETE_CONTAINER_ELEMENT}
      confirmLabel="Yes, Delete"
      cancelLabel="Cancel"
      mainButtonType="error"
      mainButtonVariant="contained"
      defaultAction="cancel"
    />
  );
};

export default ConfirmDeleteElement;
